import React from 'react'

import { useHistory } from 'react-router'
import { Button, Typography, useDimensions } from '@telavita-core/react-design-kit'

import Footer from 'components/Footer'
import HeaderMenu from 'containers/HeaderMenu'

import * as routes from 'settings/_routesSettings'

import { ReactComponent as CheckIcon} from 'static/svg/icon-check-green.svg'

import * as S from './styles'

export function CheckoutCreditCardSuccess(): JSX.Element {
  const history = useHistory()

  const { isMobile } = useDimensions()

  return (
    <S.CheckoutCreditCardSuccessContainer>
      <HeaderMenu />
      <S.MessageContainer>
        <CheckIcon />
        <Typography variant='header4' weight='bold' center>
          Consulta agendada com sucesso!
        </Typography>

        <Typography variant='content2' center>
          <br />
          Você receberá um e-mail de confirmação com os detalhes. Também enviaremos um SMS perto da data agendada, para garantir que você não perca a consulta.
        </Typography>
        <Button 
          variant='contained' 
          onClick={() => history.push(routes.DASHBOARD_APPOINTMENTS)}
        >
          VER MINHAS CONSULTAS
        </Button>
      </S.MessageContainer>
      <Footer
        isMobile={isMobile}
      />
    </S.CheckoutCreditCardSuccessContainer>
  )
}